import { connect } from 'react-redux'
/**
 * Import
 * - Store
 */
import { RootState } from '../../../store'

/**
 * Import
 * - Actions
 */
import { getPolicySingle, extendSubjectivity, getSubjectivity, resetQuotes } from '../../../actions'

/**
 * Import
 * - Page component
 */
import BindQuote from '../../../components/pages/Clients/components/BindQuote'

const mapStateToProps = (state: RootState) => {
   return {
       quote: state.quote,
       policy: state.policiesSingle,
       subjectivities: state.subjectivities,
   }
}

export default connect(
   mapStateToProps,
   {
       quote: 'The Policy! Summary',
       getPolicySingle: getPolicySingle,
       extendSubjectivity: extendSubjectivity,
       getSubjectivity: getSubjectivity,
       resetQuotes: resetQuotes,
   }
)(BindQuote)



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/containers/pages/Clients/BindQuote.tsx